export const LIST_PATH = '/list';
export const MAP_PATH = '/map';
export const DEFAULT_ROUTE = MAP_PATH;

// Due to backwards compatibility where we need to check both "/#list" and "/#/list" we check simply for the
// occurrence of "list". Keep in mind that the entire URL including search parameter are checked.
export const getBasePath = () => (window.location.hash.includes('list') ? LIST_PATH : MAP_PATH);

export const routes = [LIST_PATH, MAP_PATH];
